module.exports = __webpack_public_path__ + "static/media/grafana-icon.1bb582bc.png";